var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:eye-linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.275 15.9952C2.425 14.8912 2 14.3382 2 12.6992C2 11.0592 2.425 10.5082 3.275 9.40322C4.972 7.19922 7.818 4.69922 12 4.69922C16.182 4.69922 19.028 7.19922 20.725 9.40322C21.575 10.5092 22 11.0602 22 12.6992C22 14.3392 21.575 14.8902 20.725 15.9952C19.028 18.1992 16.182 20.6992 12 20.6992C7.818 20.6992 4.972 18.1992 3.275 15.9952Z",
    stroke: "#8147E7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 12.6992C15 13.4949 14.6839 14.2579 14.1213 14.8205C13.5587 15.3831 12.7956 15.6992 12 15.6992C11.2044 15.6992 10.4413 15.3831 9.87868 14.8205C9.31607 14.2579 9 13.4949 9 12.6992C9 11.9036 9.31607 11.1405 9.87868 10.5779C10.4413 10.0153 11.2044 9.69922 12 9.69922C12.7956 9.69922 13.5587 10.0153 14.1213 10.5779C14.6839 11.1405 15 11.9036 15 12.6992Z",
    stroke: "#8147E7",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.df1897fb83947d286cc07602fb5db9d0.svg";
export { ForwardRef as ReactComponent };